export const StellarDevelopmentProcessData = {
  mainText: `Our Stellar Development Process`,
  description: `We work out what you need, design an architecture that holds up under load, build and security-audit everything on testnet, then deploy to mainnet with proper monitoring in place. You get honest advice at the start, tested practices throughout, and support that continues after launch.`,
  services: [
    {
      step: '1',
      title: 'Discovery & Strategy',
      description:
        "We start by understanding the problem you're trying to solve, not the technology that sounds appealing. Sometimes Stellar is the right fit and sometimes it isn't, and we'll tell you exactly what to use.",
      stepColor: '#FFD900',
    },
    {
      step: '2',
      title: 'Architecture & Design',
      description:
        "We map out your system, choose the right Stellar and Soroban features, and design for scale from the start, since adding scalability after launch costs far more than building it in.",
      stepColor: '#FFD900',
    },
    {
      step: '3',
      title: 'Development & Testing',
      description:
        "We build and test on Stellar's Testnet and Futurenet, so no real funds are ever at risk during development. Our developers use the official Stellar SDKs and the Soroban toolchain and follow established best practices.",
      stepColor: '#FFD900',
    },
    {
      step: '4',
      title: 'Security Audits',
      description:
        'Blockchain development carries higher stakes than typical web work, since a single error can be expensive and irreversible. We run thorough security reviews and test for the edge cases that are easy to miss.',
      stepColor: '#FFD900',
    },
    {
      step: '5',
      title: 'Deployment & Support',
      description:
        'We deploy to mainnet with monitoring in place, clear documentation, and ongoing support.',
      stepColor: '#FFD900',
    },
  ],
};
